import React from 'react';
import { Divider, Flex, Heading, useTheme } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { CurrencyInput } from 'ts/common/components';
import { useTranslate } from 'ts/common/hooks';
import { type FormFields } from 'client_react/invoice/components/StripeInvoicePaymentForm';

type Props = {
    currencyCode: string;
};

function InvoiceTipSection({ currencyCode = 'USD' }: Props) {
    const t = useTranslate('clientInvoice');
    const theme = useTheme();

    return (
        <>
            <Flex flexDirection="column" gap="16px" fontFamily={theme.fonts.body}>
                <Heading as="h3" size="lg" margin={0}>
                    {t('tipHeading')}
                </Heading>
                <Controller<FormFields, 'tipAmount'>
                    name="tipAmount"
                    render={({ field }) => (
                        <CurrencyInput
                            {...field}
                            currencyCode={currencyCode}
                            onChange={(event) => field.onChange(Number(event.target.value))}
                        />
                    )}
                />
            </Flex>
            <Divider />
        </>
    );
}

export default InvoiceTipSection;
